import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseClass } from '../../utility/baseClass';
import { HubService } from '../../main-layout/hub/hub.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-hubmodal',
  templateUrl: './hubmodal.component.html',
  styleUrls: ['./hubmodal.component.css']
})
export class HubmodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  saveTitle = 'Add'
  hubform: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  existingdetails: any = {}
  activeFlag = [
    { labelname: 'Active', value: 'Y' },
    { labelname: 'Inactive', value: 'N' }
  ];
  temphub: any;
  constructor(
    private hubService: HubService,
    private fb: FormBuilder,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private spinnerservice: NgxSpinnerService
  ) {
    super(injector);
    this.gettoken()
    const dataFromParent = this.config.data;
    if (dataFromParent?.title == 'Modify Hub') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.existingdetails = dataFromParent.datas
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0])
    }
  }

  getData() {
    this.patchValueForms(this.existingdetails[0])
  }

  public validation_message = {
    'name': [
      { type: 'required', message: 'Hub name is required.' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters not allowed ( % and \' ).' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
  };

  patchValueForms(data) {
    this.hubform.patchValue({
      name: data?.name,
      activeflag: data?.activeflag
    });
  }

  formInitiliaze() {
    this.hubform = this.fb.group({
      name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR)])],
      activeflag: ['Y'] // Ensure this field is included if needed
    })
  }

  add() {
    if (this.hubform.invalid) {
      this.validateAllFormFields(this.hubform);
      return; // Exit early if the form is invalid
    } else {
      if (this.saveTitle == 'Modify') {
        this.modify(this.hubform.value)
      } else {
        if (this.hubform.invalid) {
          this.validateAllFormFields(this.hubform);
        }
        else {
          Swal.fire({
            title: "Do you want to save the changes?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Save",
            denyButtonText: `Don't Save`
          }).then((value) => {
            if (value.isConfirmed) {
              let data = this.hubform.value;
              data['csrftoken'] = this.CSRFToken
              this.hubService.addHub(this.hubform.value).subscribe((data) => {
                this.temphub = data;
                if (this.temphub.response == 'exists') {
                  Swal.fire("Hub already exists", " ", "error").then(result => {
                    this.ref.close()
                  });
                } else {
                  Swal.fire("Hub added successfully!", "", "success").then(result => {
                    this.ref.close()
                  });

                }
              }, error => {
                this.spinnerservice.hide();
                if (error.error.response == 'html') {
                      Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                      })
                    }       
              else{ 
                Swal.fire("Error!", error.error.response, "error");}
              });
            } else if (value.isDenied) {
              Swal.fire("Changes are not saved", "", "info")
            }
          });
        }
      }
    }
  }
  
  modify(data: any) {
    if (!data.name || data.name.trim() === '') {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Hub name cannot be empty!',
      });
      return;
    }
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          let data = this.hubform.value;
          data['csrftoken'] = this.CSRFToken
          data.hubid = this.existingdetails[0].hubid
          console.log(data);
          this.spinnerservice.show()
          // this.hubService.updateHubs(data).subscribe((data) => {
          //   this.spinnerservice.hide()

          //   Swal.fire("Updated!", "", "success").then(result => {
          //     this.ref.close()
          //   });
          // }, error => {
          //   this.spinnerservice.hide()

          //   Swal.fire({
          //     icon: "error",
          //     title: "Oops...",
          //     text: error.error.error,
          //     footer: "error status is :" + ' ' + error.status
          //   });
          // });
          // Swal.fire("Saved!", "", "success").then(result => {
          //   this.ref.close()
          // });
          this.hubService.updateHubs(data).subscribe({
            next: (response: any) => {
              this.spinnerservice.hide()
              if (response?.response === 'exists') {
                Swal.fire("Hub already exists!", "", "error");
              } else {
                Swal.fire("Hub modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              this.spinnerservice.hide()
              if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.error?.error || "An unexpected error occurred.",
                footer: `Error status is: ${error.status}`
              });
            }
            }
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
  }


  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}
